import React from "react";
import "../style/OrlandoTransportation.css";
import SEO from "./SEO";

const OrlandoTransportation = ({ currentLanguage = "EN" }) => {
  // JSON-LD structured data for local business
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://orlandoairportslimoride.com/orlando-transportation",
    "name": "Gators Transportation Inc.",
    "description": "Professional Orlando transportation service to Disney World, Universal Studios, and SeaWorld. Premium airport transfers and theme park shuttles.",
    "url": "https://orlandoairportslimoride.com/orlando-transportation",
    "telephone": "+1 407-501-3333",
    "email": "gatorstransportation87@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "2800 North Poinciana Blvd",
      "addressLocality": "Kissimmee",
      "addressRegion": "FL",
      "postalCode": "32801",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 28.5383,
      "longitude": -81.3792
    },
    "areaServed": {
      "@type": "Place",
      "name": "Greater Orlando Area"
    },
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": 28.5383,
        "longitude": -81.3792
      },
      "geoRadius": "50"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Orlando Transportation Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Disney World Transportation",
            "description": "Direct transportation from Orlando Airport to Disney World Resort hotels and theme parks"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Universal Studios Shuttle",
            "description": "Convenient shuttle service to Universal Studios Orlando and Islands of Adventure"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "SeaWorld Orlando Transport",
            "description": "Reliable transportation to SeaWorld Orlando theme park and attractions"
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "250"
    },
    "openingHours": "Mo-Su 00:00-23:59",
    "priceRange": "$$"
  };

  return (
    <>
      <SEO
        title="Orlando Transportation Service Disney Universal SeaWorld"
        description="Premium Orlando transportation service to Disney World, Universal Studios & SeaWorld. Professional airport transfers, theme park shuttles, and luxury vehicles."
        keywords="Orlando transportation service, Disney World shuttle, Universal Studios transport, SeaWorld Orlando, MCO airport transfer, theme park transportation, Orlando airport shuttle, Disney resort transportation"
        canonical="/orlando-transportation"
        jsonLd={jsonLd}
        openGraph={{
          title: "Orlando Transportation Service to Disney Universal SeaWorld",
          description: "Professional Orlando transportation service to all major theme parks. Luxury vehicles, experienced drivers, competitive rates.",
          image: "https://orlandoairportslimoride.com/images/orlando-transportation-service.jpg",
          type: "website"
        }}
        twitterCard={{
          card: "summary_large_image",
          title: "Orlando Transportation Service Disney Universal SeaWorld",
          description: "Premium transportation to Disney World, Universal Studios & SeaWorld. Book your Orlando theme park shuttle today!",
          image: "https://orlandoairportslimoride.com/images/orlando-transportation-service.jpg"
        }}
      />

      <main className="orlando-transportation-page">
        {/* Hero Header Section */}
        <header className="hero-header">
          <div className="hero-content">
            <h1 className="hero-title">
              Orlando Transportation Service Disney Universal SeaWorld
            </h1>
            <p className="hero-subtitle">
              Professional luxury transportation to all major Orlando theme parks. 
              Experience comfort and reliability with our premium fleet and expert drivers.
            </p>
            <div className="hero-cta">
              <button className="cta-button primary">Book Now</button>
              <button className="cta-button secondary">Get Quote</button>
            </div>
          </div>
          <div className="hero-image">
            <img 
              src="https://orlandoairportslimoride.com/images/orlando-transportation-luxury-van.jpg" 
              alt="Luxury transportation van for Orlando Disney Universal SeaWorld service"
              className="hero-img"
              loading="eager"
              width="600"
              height="400"
            />
          </div>
        </header>

        {/* Main Content Sections */}
        <section className="services-overview">
          <div className="container">
            <h2 className="section-title">
              Premium Orlando Transportation Service to Disney, Universal & SeaWorld
            </h2>
            <div className="services-grid">
              <div className="service-card">
                <img 
                  src="https://orlandoairportslimoride.com/images/disney-world-transportation.jpg" 
                  alt="Disney World transportation service Orlando"
                  className="service-image"
                  loading="lazy"
                  width="300"
                  height="200"
                />
                <h3>Disney World Transportation</h3>
                <p>
                  Direct shuttle service from Orlando International Airport to all Disney World 
                  resort hotels and theme parks. Comfortable, air-conditioned vehicles with 
                  professional drivers who know the best routes.
                </p>
              </div>

              <div className="service-card">
                <img 
                  src="https://orlandoairportslimoride.com/images/universal-studios-shuttle.jpg" 
                  alt="Universal Studios Orlando transportation shuttle service"
                  className="service-image"
                  loading="lazy"
                  width="300"
                  height="200"
                />
                <h3>Universal Studios Shuttle</h3>
                <p>
                  Convenient transportation to Universal Studios Orlando and Islands of Adventure. 
                  Skip the hassle of parking and traffic with our reliable shuttle service.
                </p>
              </div>

              <div className="service-card">
                <img 
                  src="https://orlandoairportslimoride.com/images/seaworld-orlando-transport.jpg" 
                  alt="SeaWorld Orlando transportation service"
                  className="service-image"
                  loading="lazy"
                  width="300"
                  height="200"
                />
                <h3>SeaWorld Orlando Transport</h3>
                <p>
                  Safe and comfortable transportation to SeaWorld Orlando. Perfect for families 
                  and groups looking for stress-free travel to this amazing marine park.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="why-choose-us">
          <div className="container">
            <h2 className="section-title">
              Why Choose Our Orlando Transportation Service?
            </h2>
            <div className="benefits-grid">
              <div className="benefit-item">
                <div className="benefit-icon">🚐</div>
                <h3>Luxury Fleet</h3>
                <p>Modern, well-maintained vehicles including SUVs, vans, and luxury sedans</p>
              </div>
              
              <div className="benefit-item">
                <div className="benefit-icon">👨‍✈️</div>
                <h3>Professional Drivers</h3>
                <p>Licensed, insured, and experienced drivers with extensive Orlando area knowledge</p>
              </div>
              
              <div className="benefit-item">
                <div className="benefit-icon">⏰</div>
                <h3>Reliable Service</h3>
                <p>On-time arrivals and departures, flight monitoring for airport pickups</p>
              </div>
              
              <div className="benefit-item">
                <div className="benefit-icon">💰</div>
                <h3>Competitive Rates</h3>
                <p>Affordable pricing with no hidden fees, transparent booking process</p>
              </div>
            </div>
          </div>
        </section>

        <section className="coverage-area">
          <div className="container">
            <h2 className="section-title">
              Complete Orlando Theme Park Transportation Coverage
            </h2>
            <div className="coverage-content">
              <div className="coverage-text">
                <p>
                  Our Orlando transportation service covers all major attractions and destinations 
                  throughout Central Florida. Whether you're visiting Disney World's Magic Kingdom, 
                  EPCOT, Hollywood Studios, or Animal Kingdom, we provide direct transportation 
                  from your hotel or Orlando International Airport.
                </p>
                <p>
                  For Universal Studios fans, we offer convenient shuttle service to both Universal 
                  Studios Florida and Islands of Adventure, including the Wizarding World of Harry Potter. 
                  SeaWorld Orlando visitors can enjoy comfortable transportation to experience marine 
                  shows and thrilling rides.
                </p>
                <ul className="destinations-list">
                  <li>Orlando International Airport (MCO) transfers</li>
                  <li>All Disney World theme parks and resort hotels</li>
                  <li>Universal Studios Orlando and Islands of Adventure</li>
                  <li>SeaWorld Orlando and Aquatica</li>
                  <li>ICON Park and International Drive attractions</li>
                  <li>Orlando City Centre and downtown Orlando</li>
                </ul>
              </div>
              <div className="coverage-image">
                <img 
                  src="https://orlandoairportslimoride.com/images/orlando-map-transportation.jpg" 
                  alt="Orlando transportation service coverage map showing Disney Universal SeaWorld"
                  className="map-image"
                  loading="lazy"
                  width="500"
                  height="400"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="booking-section">
          <div className="container">
            <h2 className="section-title">
              Book Your Orlando Transportation Service Today
            </h2>
            <div className="booking-content">
              <div className="booking-form">
                <h3>Get Instant Quote</h3>
                <form className="quote-form">
                  <div className="form-group">
                    <label htmlFor="pickup-location">Pickup Location</label>
                    <select id="pickup-location" name="pickup-location">
                      <option value="">Select pickup location</option>
                      <option value="mco">Orlando International Airport (MCO)</option>
                      <option value="hotel">Orlando Hotel</option>
                      <option value="address">Custom Address</option>
                    </select>
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="destination">Destination</label>
                    <select id="destination" name="destination">
                      <option value="">Select destination</option>
                      <option value="disney">Disney World Resort</option>
                      <option value="universal">Universal Studios Orlando</option>
                      <option value="seaworld">SeaWorld Orlando</option>
                      <option value="other">Other Orlando Attraction</option>
                    </select>
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="passengers">Number of Passengers</label>
                    <select id="passengers" name="passengers">
                      <option value="1-3">1-3 passengers</option>
                      <option value="4-7">4-7 passengers</option>
                      <option value="8-14">8-14 passengers</option>
                      <option value="15+">15+ passengers</option>
                    </select>
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="date">Travel Date</label>
                    <input type="date" id="date" name="date" required />
                  </div>
                  
                  <button type="submit" className="submit-button">
                    Get Instant Quote
                  </button>
                </form>
              </div>
              
              <div className="contact-info">
                <h3>Contact Information</h3>
                <div className="contact-details">
                  <p><strong>Phone:</strong> <a href="tel:+14075013333">+1 (407) 501-3333</a></p>
                  <p><strong>Email:</strong> <a href="mailto:gatorstransportation87@gmail.com">gatorstransportation87@gmail.com</a></p>
                  <p><strong>Available:</strong> 24/7 Service</p>
                </div>
                
                <div className="service-highlights">
                  <h4>Service Highlights:</h4>
                  <ul>
                    <li>✓ Free flight monitoring for airport pickups</li>
                    <li>✓ Meet & greet service available</li>
                    <li>✓ Child car seats provided upon request</li>
                    <li>✓ Wheelchair accessible vehicles</li>
                    <li>✓ Luggage assistance included</li>
                    <li>✓ Multiple language support</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action Footer */}
        <section className="final-cta">
          <div className="container">
            <div className="cta-content">
              <h2>Ready to Experience Premium Orlando Transportation Service?</h2>
              <p>
                Don't let transportation stress ruin your Disney, Universal, or SeaWorld vacation. 
                Book with Gators Transportation for reliable, comfortable, and professional service 
                to all Orlando theme parks and attractions.
              </p>
              <div className="cta-buttons">
                <button className="cta-button primary large">
                  Book Your Transportation Now
                </button>
                <button className="cta-button secondary large">
                  Call (407) 501-3333
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default OrlandoTransportation;
